import { ResumeBuilderCore } from "@/components/resume/ResumeBuilderCore";
import { ShareButton } from "@/components/common/ShareButton";

export default function MemberResumePage() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div>
          <h1 className="text-2xl sm:text-3xl font-heading font-semibold tracking-tight">Resume Builder</h1>
          <p className="text-muted-foreground mt-1 text-sm">Edit on the left, preview live on the right. Download as PDF anytime.</p>
        </div>
        <ShareButton
          url={`${window.location.origin}/resume-builder`}
          text="Create your FREE professional resume with Udhyog Tech:"
          testIdPrefix="member-resume-share"
          label="Share this tool"
          className="shrink-0"
        />
      </div>
      <ResumeBuilderCore />
    </div>
  );
}
